import imagesLoaded from "imagesloaded";

/**
 *  Checks if images have fully loaded and fades them in.
 *
 * @param  container  Parent element containing images which will be faded in
 */
export const fadeIn = (container) => {
  const imgLoad = imagesLoaded(container);
  imgLoad.on("progress", (instance, image) => {
    var result = image.isLoaded ? "loaded" : "broken";

    if (image.isLoaded) {
      image.img.style.opacity = "1";
    }
  });
};
